import { BaseForm } from './base-Form';

export class DatiGeneraliConFondoRischiForm extends BaseForm {

  checkFondoRischiRemoved: boolean = false;
  confermaFrChangeChecked: boolean = false;
  changeFondoRischi: boolean = false;
  initialValueDVFR: number;

  inizializzaFondoRischi(fondoRischi: boolean, initialValueDVFR: number) {
    this.changeFondoRischi = false;
    this.initialValueDVFR = initialValueDVFR;
    if (!this.inserimento && fondoRischi && !this.wizard) {
      this.checkFondoRischiRemoved = true;
    } else {
      this.checkFondoRischiRemoved = false;
    }
  }

  notifyConferma(statoConfermaFondoRischi: boolean) {
    this.confermaFrChangeChecked = statoConfermaFondoRischi;
  }

  changedFondoRischiState() {
    this.confermaFrChangeChecked = false;
    this.changeFondoRischi = !this.changeFondoRischi;
  }
}
